export default __webpack_public_path__ + "static/media/refreshIconWhite.de7a2efa.svg";